import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../../../hooks'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../../Table'

import { renderApplicantProfileViewingsCell } from './ApplicantProfileViewingsRow.utils'

import * as styles from './ApplicantProfileViewingsRow.module.css'

function ApplicantProfileViewingsRow({
  actionLeft,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  getArrowNavigationItemProps,
  index,
  isResizing,
  item,
  resizingColumn,
  showCellBorder,
  ...restProps
}) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { handleCallAction, handleMouseEnter, handleMouseLeave } =
    useTableRowActions({ item, ...restProps })

  const className = useTableRowModClassName({
    className: styles.ApplicantProfileViewingsRow,
    isActive: focusedRow === item.id,
  })

  return (
    <div
      {...getTableRowQaProps()}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderApplicantProfileViewingsCell({
            isActive: column.name === resizingColumn,
            isResizing,
            item,
            locale,
            name: column.name,
            showCellBorder,
            t,
            timezone,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item)?.length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default ApplicantProfileViewingsRow
